export default "__VITE_ASSET__D9kjzjv0__"